// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { Injectable } from '@angular/core';
import { StatePersister } from '../../services/state-persister';
import * as fromLanguageTranslations from './language-translation.reducer';

@Injectable({
  providedIn: 'root'
})
export class LanguageTranslationPersisterService extends StatePersister<fromLanguageTranslations.State> {
  constructor() {
    super(localStorage, fromLanguageTranslations.featureKey);
  }
}
